<template>
  <div class="jobs-list" v-loading="loader">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <div class="jobs-ul">
      <div class="jobs-li">
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <span>Зона работ</span>
        </div>
        <router-link :to="`/dashboard/zones`">
          <i class="fa fa-edit"></i>
        </router-link>
      </div>
    </div>
    <draggable
      class="jobs-ul"
      style="margin-top: -2px"
      handle=".handle"
      :list="inputs" @change="save"
    >
      <div
        class="jobs-li" v-for="(input, index) in filteredList" :key="index"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <span>{{ input.name || input.label }}</span>
        </div>
        <router-link :to="`/dashboard/inputs/${input.id}/edit`" v-if="input.type.value !== 'population' && input.type.value !== 'tech'">
          <i class="fa fa-edit"></i>
        </router-link>
      </div>
    </draggable>
    <router-link :to="`/dashboard/inputs/create`" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getAllInputs} from "../../../firestore/inputs";

export default {
  name: 'List',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      inputs: [],
    };
  },

  mounted() {
    this.fetchJobs();
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const inputs = this.inputs.map((input, index) => {
        return {
          ...input,
          _data: {
            ...input._data,
            index: index,
          },
        };
      });

      this.update(inputs);
    }, 1000),

    async fetchJobs() {
      this.loader = true;
      const result = []
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .get()
        .then(async (data) => {

            data.forEach((subDoc) => {
              let _data = subDoc.data();
              if(!_data.type) {
                _data.type = {
                  label: 'Текст',
                  value: 'text',
                }
              }

              result.push({..._data, id: subDoc.id});
            });

            if (!result.find(({type}) => type && type.value === 'population')) {
              const index = result.length + 1

              const project = await myFirestore
                .collection('projects')
                .doc(this.$store.state.project.id)
                .collection('inputs')
                .add({
                  name: 'Численность',
                  defaultFields: {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null,
                  },
                  isZone: false,
                  isEditable: false,
                  operation: null,
                  dirs: [],
                  volumeId: {
                    1: false,
                    2: false,
                    3: false,
                    4: false,
                    5: false
                  },
                  options: [],
                  labels: {
                    1: '',
                    2: '',
                    3: '',
                    4: '',
                    5: ''
                  },
                  type: {
                    label: 'Численность',
                    value: 'population',
                  },
                  index,
                })


              result.push({
                name: 'Численность',
                type: {
                  label: 'Численность',
                  value: 'population',
                },
                id: project.id,
                index
              })

            }

          if (!result.find(({type}) => type && type.value === 'tech')) {
            const index = result.length + 1

            const project = await myFirestore
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('inputs')
              .add({
                name: 'Техника',
                defaultFields: {
                  1: null,
                  2: null,
                  3: null,
                  4: null,
                  5: null,
                },
                isZone: false,
                isEditable: false,
                operation: null,
                dirs: [],
                volumeId: {
                  1: false,
                  2: false,
                  3: false,
                  4: false,
                  5: false
                },
                options: [],
                labels: {
                  1: '',
                  2: '',
                  3: '',
                  4: '',
                  5: ''
                },
                type: {
                  label: 'Техника',
                  value: 'tech',
                },
                index,
              })


            result.push({
              name: 'Техника',
              type: {
                label: 'Техника',
                value: 'tech',
              },
              id: project.id,
              index
            })

          }

            this.inputs = [..._.orderBy(result, 'index', ['asc'])];

          }
        ).finally(() => {
        this.loader = false;
      })
    },
    update(works) {
      let batch = myFirestore.batch();
      works.forEach((doc) => {
        const docRef = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    }
    ,
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    }
    ,
  },

  computed: {
    filteredList() {
      return this.inputs.filter(input => {
        if (!input.name) {
          return !this.search
        }
        return (input.name || input.label).toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Index.vue